(ns common.schema.entities.workspace.kyc.templates.demo.natural-person
  (:require
   [common.schema.entities.workspace.kyc.questions.questions-registry :as questions-registry]
   [common.schema.entities.workspace.kyc.templates.demo.pep :as pep]
   [common.schema.entities.workspace.kyc.templates.demo.ubo :as ubo]
   [common.schema.entities.workspace.kyc.templates.demo.company-config :as company-config]))

(def schema
  {:kyc-template/template-name
   "Natural person"

   :kyc-template/kyc-form-preface
   company-config/form-preface-text

   :kyc-template/svg-logo
   company-config/svg-logo


   :kyc-template/png-logo
   company-config/png-logo

   :kyc-template/help-email-address
   company-config/contact-email

   :kyc-template/kyc-form-title
   {:translations {:en "Know Your Customer (KYC) form"
                   :fi "Asiakastietokysely"}}


   :kyc.natural-person/basic-information
   {:ord          1.0
    :translations {:en "Basic information"
                   :fi "Perustiedot"}
    :pdf-columns  2
    :questions    (questions-registry/resolve-questions
                   [[:kyc-person/first-name]
                    [:kyc-person/last-name]
                    [:kyc-person/nationality]
                    [:kyc-person/dob]
                    [:kyc-person/pob]
                    [:kyc-person/pin]
                    [:kyc-person/address]
                    [:kyc-person/zip-code]
                    [:kyc-person/city]
                    [:kyc-person/country]
                    [:kyc-person/email]
                    [:kyc-person/phone]
                    [:kyc-person/occupation]
                    [:kyc-person/actual-line-of-business]
                    [:kyc-person/size-of-investment-portfolio]
                    [:kyc-person/source-of-funds]
                    [:kyc-person/source-of-funds-salaries-amount]
                    [:kyc-person/source-of-funds-capital-income-amount]
                    [:kyc-person/source-of-funds-inheritance-amount]
                    [:kyc-person/source-of-funds-other-amount]
                    [:kyc-person/source-of-funds-other-specify]
                    [:kyc-person/source-of-wealth]
                    [:kyc-person/other-person-investment?]
                    [:kyc-person/ubo-edn {:data/template ubo/schema}]
                    [:kyc-person/PEP?]
                    [:kyc-person/pep-edn {:data/template pep/schema}]])}

   ; Removed as per ticket DEV-5104
   #_:kyc.natural-person/investor-categorization
   #_{:ord          2.0
      :translations {:en "Investor categorization"
                     :fi "Sijoittajaluokitus"}
      :questions
      (questions-registry/resolve-questions
       [[:kyc-person/professional-investor?]
        [:kyc-person/professional-investor-criterias]
        [:kyc-person/professional-investor-notes]
        [:kyc-person/non-professional-investor-notes]])}
   :kyc.natural-person/tax-reporting-information
   {:ord          2.0
    :translations {:en "Tax reporting information"
                   :fi "Verotiedot"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-person/tax-countries]
                    [:kyc-person/usa-tax-residency]])}

   :kyc.natural-person/additional-documents
   {:ord
    3.0

    :translations
    {:en "Additional documents"
     :fi "Liitetiedostot"}

    :keep-together?
    true

    :info
    {:en ""
     :fi ""}

    :questions
    (questions-registry/resolve-questions
     [[:kyc-person/number-of-documents]
      [:kyc-person/document-1]
      [:kyc-person/document-2]
      [:kyc-person/document-3]
      [:kyc-person/document-4]
      [:kyc-person/document-5]])}

   :kyc.natural-person/identification
   {:ord          4.0
    :translations {:en "Identification"
                   :fi "Tunnistetiedot"}
    :info         {:en ""
                   :fi ""}
    :questions
    (questions-registry/resolve-questions
     [[:kyc-person/signer-email]
      [:kyc-person/type-of-identification-attachment]
      [:kyc-person/identification-expires]
      [:kyc-person/identification-attachment]])}
   :kyc.natural-person/confirmation
   {:ord          5.0
    :translations {:en "Confirmation"
                   :fi "Tietojen vahvistaminen"}
    :questions    (questions-registry/resolve-questions
                   [[:kyc-person/confirmation-place]
                    [:kyc-person/confirmation-date]
                    [:kyc-person/confirmation-name]])}

   :kyc.natural-person/signature-info
   {:ord
    6.0
    :translations
    {:en ""
     :fi ""}

    :end-of-pdf?
    true

    :page-break-before?
    true

    :conditional-block
    (fn [answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))

    :questions
    (questions-registry/resolve-questions
     [[:kyc-person/signature-confirmation]])}


   :kyc.natural-person/signature
   {:ord
    7.0
    :translations
    {:en "Signatures"
     :fi "Allekirjoitukset"}
    :keep-together?
    true

    :end-of-pdf?
    true

    :conditional-block
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))
    :section-not-read-only
    (fn [_answers kyc-process]
      (some #{(:kyc-process/status kyc-process)}
            [:kyc-process.status/signatures
             :kyc-process.status/waiting-for-e-sign]))
    :questions
    (questions-registry/resolve-questions
     [[:kyc-legal-entity/signature-place
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]
      [:kyc-legal-entity/signature-date
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]
      [:kyc-legal-entity/signature-name
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]
      [:kyc-legal-entity/signature-signature
       {:conditional-field (fn [_answers kyc-process]
                             (some #{(:kyc-process/status kyc-process)}
                                   [:kyc-process.status/signatures
                                    :kyc-process.status/waiting-for-e-sign]))}]])}})
